module.exports = __webpack_public_path__ + "static/media/marker_gray.b5837bc3.png";